import React from "react";

const R = 11;
const C = 12;
const CIRC = 2 * Math.PI * R; // ≈ 69.115

export default function Spinner({ size = 24, strokeWidth = 2 }) {
  const scale = size / 24;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ animation: "spin .65s linear infinite", flexShrink: 0 }}
    >
      {/* track ring */}
      <circle
        cx={C} cy={C} r={R}
        fill="none"
        stroke="var(--border-color)"
        strokeWidth={strokeWidth}
      />
      {/* arc with rounded caps */}
      <circle
        cx={C} cy={C} r={R}
        fill="none"
        stroke="var(--text-primary)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={`${CIRC * 0.25} ${CIRC * 0.75}`}
        style={{ transformOrigin: "center", transform: "rotate(-90deg)" }}
      />
    </svg>
  );
}
